(function () {
    tabs($('.common-tabs>.common-tab-item'), $('.common-wrapper'), 'active', 'show');
})();
//首页菜单切换【课程试听/名师集体/律师助理课程/企业法务专员课程/资讯感悟】
function tabs(menu, cont, cur, show) {
    menu.click(function () {
        const index = menu.index(this);
        $(this).addClass(cur).siblings().removeClass(cur);
        cont.children().eq(index).addClass(show).siblings().removeClass(show);
    });
}


